import { FC } from "react"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination, Navigation } from "swiper/modules"

const WhyMatters: FC = () =>
  <div className='why-matters container-fluid' id='why-matters'>
    <div className="row why-matters__title">
      <h1>Почему расчет освещения так важен?</h1>
    </div>
    <div className="row why-matters__text1">
      <h2><span className='text-accent'>
        Светотехнический расчет</span> — это инструмент, позволяющий достичь оптимального баланса между яркостью, цветовой температурой и распределением света.</h2>
    </div>
    <div className="row why-matters__text2">
      <h2>Правильное освещение способствует повышению производительности, снижению уровня усталости и созданию комфортной атмосферы внутри помещений и на открытых площадках.</h2>
    </div>
    <div className="row why-matters__content">
      <div className="col">
        <Swiper
          pagination={true}
          navigation
          modules={[Pagination, Autoplay, Navigation]}
          autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          }}
          className="mySwiper">
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
        </Swiper>
      </div>
      <div className="col-md-7 col-lg-4 col tips">
        <div className="content-tips">
          <h3 className="tips-title">Мы проектируем освещение:</h3>
          <ol className='tips-list'>
            <li>промышленных помещений;</li>
            <li>спортивных комплексов;</li>
            <li>общественных помещений;</li>
            <li>школ и больниц;</li>
            <li>улиц и дорог;</li>
            <li>архитектурных объектов.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

export default WhyMatters;
